<template>
  <div class="choose-course">
    <Modal
      v-model="show"
      :title="`${orgType == 1 ? '选择学校' : '选择机构'}`"
      :footer-hide="true"
      width="80"
    >
      <div class="flex">
        <div class="left">
          <div class="search-line">
            <Input
              v-model="searchData.orgName"
              class="search-input"
              :placeholder="`${
                orgType == 1 ? '请输入学校名称' : '请输入机构名称'
              }`"
              clearable
            ></Input>
            <div class="flex align-items" style="margin-right: 8px">
              {{ yearTermStr }}
            </div>

            <Button
              type="primary"
              style="margin-right: 8px"
              @click="handleGetSearchValue"
            >搜索</Button>
            <Button class="reset-btn" @click="handleResetSearch">重置</Button>
          </div>
          <Tabs :value="tabSelect" type="card" @on-click="changeTab">
            <TabPane name="org" label="机构"></TabPane>
            <TabPane name="sch" label="学校"></TabPane>
          </Tabs>
          <div class="table">
            <Table
              ref="selection"
              border
              :columns="tableColumn"
              :data="tableList"
              :loading="tableLoading"
              @on-select="onSelect"
              @on-select-cancel="onSelectCancel"
              @on-select-all="onSelectAll"
              @on-select-all-cancel="onSelectAllCancel"
              @on-selection-change="onSelectionChange"
            ></Table>
            <div class="page-main">
              <Page
                :total="pageInfo.total"
                show-total
                :current="pageInfo.pageNum"
                class="page-right"
                @on-change="handlePageChange"
              ></Page>
            </div>
            <!-- <div class="iconTips">
              <Icon
                type="md-alert"
                size="16"
                color="#ff9900"
                style="padding-right: 10px"
              ></Icon
              >商品选择范围不含圈定报名范围、预报名的课程商品
            </div> -->
          </div>
        </div>
        <div class="right">
          <div class="head">选中({{ selectOrgList.length }})</div>
          <div class="right-table">
            <Table
              :columns="rightColumns"
              border
              :data="selectOrgList"
              height="550"
            ><template slot="action" slot-scope="{ row, index }">
              <Button
                type="error"
                size="small"
                @click="handleRemove(row, index)"
              >删除</Button>
            </template></Table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <Button
          style="margin-right: 16px"
          @click="handleCancleBtn"
        >取消</Button>
        <Button type="primary" @click="handleSureBtn">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

import platformApi from '@/request/eduCenter/platform.js';
export default {
  components: {

  },
  props: {
    yearTermStr: {
      type: String,
      default: ''
    },
    schoolId: {
      type: String,
      default: ''
    },
    orgType: {
      type: String,
      default: '4'
    },
    nowSelectSchoolInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: false,
      searchData: {
        orgName: '',
        orgId: ''
      },

      selectOrgList: [], // 选中的课程
      schRightColumns: [{
        title: '学校名称',
        key: 'name'
      },
      {
        title: '操作',
        slot: 'action',
        width: 150,
        align: 'center'
      }],
      orgRightColumns: [{
        title: '机构名称',
        key: 'name'
      },
      {
        title: '操作',
        slot: 'action',
        width: 150,
        align: 'center'
      }],
      schTableColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '学校名称',
          key: 'name'
        }, {
          title: '区域',
          key: 'areaName'
        }
      ], //
      orgTableColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '机构名称',
          key: 'name'
        }, {
          title: '区域',
          key: 'areaName'
        }
      ], //
      tableList: [], //
      pageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      portOrg: Number(localStorage.getItem('portOrg')),
      tableLoading: false,
      tabSelect: 'org'
    };
  },
  computed: {

    rightColumns() {
      return this.orgRightColumns;
    },
    tableColumn() {
      return this.schTableColumn;
    }
  },
  created() { },
  mounted() { },
  methods: {
    changeTab(name) {
      this.tabSelect = name;
      if (this.tabSelect === 'org') {
        this.init();
      } else {
        this.pageInfo = {
          total: 1,
          pageSize: 10,
          pageNum: 1
        };
        this.tableList = [{ ...this.nowSelectSchoolInfo }];
        this.handleOrgList();
      }
    },
    init() {
      this.pageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      this.tableList = [];
      this.getOrgList();
    },
    open(productList) {
      this.show = true;
      this.tabSelect = 'org';
      this.selectOrgList = productList;
      this.init();
    },
    handleCancleBtn() {
      this.show = false;
    },
    // 提交
    handleSureBtn() {
      // if (this.selectOrgList.length < 2) {
      //   this.$Message.error('至少选择2门课程商品');
      //   return null;
      // }
      this.show = false;
      this.$emit('on-finish', this.selectOrgList);
    },

    getSelectCourseRow(row) {
      console.log(row);
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getOrgList();
    },

    //
    async getOrgList() {
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        schoolId: this.schoolId,
        orgName: '',
        orgType: this.orgType
      };
      const paramsTrue = Object.assign(params, this.searchData);
      let res;
      //
      this.tableLoading = true;

      res = await platformApi.getSchoolRelOrg(paramsTrue);

      this.tableLoading = false;
      if (res.status === 200) {
        this.tableList = res.message.list.map(item => {
          // item.classTimeShow = dealTimeList(item);
          item.id = item.orgId;

          return item;
        });
        this.pageInfo.total = Number(res.message.total);
        this.handleOrgList();
      }
    },
    handleGetSearchValue() {
      this.pageInfo.pageNum = 1;
      this.pageInfo.total = 0;
      this.getOrgList();
    },
    handleResetSearch() {
      this.searchData.orgName = '';
      this.$nextTick(() => {
        this.handleGetSearchValue();
      });
    },
    onSelectionChange(selection, row) { },
    onSelectCancel(selection, row) {
      const key = this.selectOrgList.findIndex(item => {
        return item.orgId == row.orgId;
      });
      if (key != -1) {
        this.selectOrgList.splice(key, 1);
      }
    },
    onSelectAll(selection) {
      selection.forEach(item => {
        this.onSelect(selection, item);
      });
    },
    onSelectAllCancel(selection) {
      this.tableList.forEach(item => {
        this.onSelectCancel(selection, item);
      });
    },
    onSelect(selection, row) {
      const key = this.selectOrgList.findIndex(item => {
        return item.orgId == row.orgId;
      });
      if (key == -1) {
        this.selectOrgList.push(row);
      }
    },
    // 删除
    handleRemove(row, index) {
      this.selectOrgList.splice(index, 1);
      this.handleOrgList();
    },
    // 处理列表选中效果
    handleOrgList() {
      this.tableList.forEach(item => {
        item._checked = false;
        const key = this.selectOrgList.findIndex(item_1 => {
          return item_1.orgId == item.orgId;
        });
        if (key != -1) {
          item._checked = true;
        }
      });
      this.tableList = Object.assign([], this.tableList);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 160px;
    margin-right: 16px;
  }
  .search-select {
    width: 250px;
    margin-right: 16px;
  }
}
.iconTips {
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin: 0 0 10px 10px;
  width: 600px;
  height: 30px;
  background-color: #fffae2;
  border: solid 1px #ffe184;
}
.page-main {
  text-align: right;
  padding: 16px 0;
}
.flex {
  display: flex;
  .left {
    width: 70%;
    margin-right: 20px;
  }
  .right {
    width: 28%;
    .head {
      background: rgba(0, 0, 0, 0.05);
      padding: 8px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }
  }
}
.modal-footer {
  text-align: right;
  padding: 10px 0;
}
</style>
